import { isTauriRuntime } from '@/helpers/resolvedPlayerAppVersion'
import { getPlatform } from '@/platform'

export interface TAndroidNetworkLinkStatus {
  wifiEnabled: boolean
  transportConnected: boolean
  connectionType: string
}

function parseNetworkLinkStatus(raw: unknown): TAndroidNetworkLinkStatus | null {
  if (raw == null || typeof raw !== 'object') {
    return null
  }
  const o = raw as Record<string, unknown>
  if (typeof o.wifiEnabled !== 'boolean' || typeof o.transportConnected !== 'boolean') {
    return null
  }
  const connectionType = typeof o.connectionType === 'string' && o.connectionType.trim().length > 0
    ? o.connectionType.trim()
    : 'unknown'
  return {
    wifiEnabled: o.wifiEnabled,
    transportConnected: o.transportConnected,
    connectionType
  }
}

/** Android-only: native Wi-Fi / transport link snapshot (ConnectivityManager). */
export async function fetchAndroidNetworkLinkStatus(): Promise<TAndroidNetworkLinkStatus | null> {
  if (!isTauriRuntime() || getPlatform() !== 'android') {
    return null
  }
  try {
    const { invoke } = await import('@tauri-apps/api/core')
    const raw = await invoke<unknown>('plugin:lucimark-android|getNetworkLinkStatus')
    return parseNetworkLinkStatus(raw)
  }
  catch {
    return null
  }
}
